var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown",
    transform: "translate(-14.000000, -52.000000)",
    fill: "#919193",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9294118,52.5 C23.4567668,52.5 25.5424035,54.2617483 25.6595196,56.5065872 L25.6647059,56.7058824 L25.664,57.446 L25.6900578,57.4471094 C26.6230861,57.5217774 27.3588235,58.2920388 27.3588235,59.2352941 L27.3588235,65.7058824 C27.3588235,66.6987827 26.543602,67.5 25.5411765,67.5 L16.3176471,67.5 C15.3152215,67.5 14.5,66.6987827 14.5,65.7058824 L14.5,59.2352941 C14.5,58.2833759 15.2493136,57.5076438 16.1945222,57.4452286 L16.1941176,56.7058824 C16.1941176,54.3669045 18.3277228,52.5 20.9294118,52.5 Z M25.5411765,58.4411765 L16.3176471,58.4411765 C15.8636649,58.4411765 15.5,58.7985942 15.5,59.2352941 L15.5,65.7058824 C15.5,66.1425823 15.8636649,66.5 16.3176471,66.5 L25.5411765,66.5 C25.9951586,66.5 26.3588235,66.1425823 26.3588235,65.7058824 L26.3588235,59.2352941 C26.3588235,58.7985942 25.9951586,58.4411765 25.5411765,58.4411765 Z M20.9294239,60.3235294 C21.4362459,60.3235294 21.8529412,60.7286603 21.8529412,61.2352941 C21.8529412,61.5583419 21.6835215,61.8401182 21.4293448,62.0019124 L21.4294118,64.5294118 C21.4294118,64.8055541 21.2055541,65.0294118 20.9294118,65.0294118 C20.6839519,65.0294118 20.4798034,64.8525366 20.4374674,64.6192874 L20.4294118,64.5294118 L20.4294787,62.0019124 C20.175302,61.8401182 20.0058824,61.5583419 20.0058824,61.2352941 C20.0058824,60.7286563 20.4225843,60.3235294 20.9294239,60.3235294 Z M21.1356608,53.5047945 L20.9294118,53.5 C18.9217425,53.5 17.3051423,54.8559681 17.1995997,56.5314585 L17.1941176,56.7058824 L17.194,57.441 L24.664,57.441 L24.6647059,56.7058824 C24.6647059,55.0095884 23.115028,53.5970771 21.1356608,53.5047945 L20.9294118,53.5 Z",
    id: "change-password"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.f6b2cb9043c2ad59ddb19d747742c26e.svg";
export { ForwardRef as ReactComponent };